<template>
  <div class="developers">
    <div class="developers__subheader mb-4" v-if="!showForm">
        <add-button class="mr-4" @click="showAddForm"></add-button>
        <limit-component v-if="developers.length >= 10" v-model="limit" @input="getDevelopers"></limit-component>
    </div>
    <spinner v-if="isBusy"/>
    <div class="tech" v-show="!isBusy">
      <div class="developers__wrapper" v-show="!showForm">
        <custom-table  v-if="$store.state.tableView.developers" class="mb-4"
                      :rows="rows"
                      :items="developers"
                      :show-edit="false"
                      @archive="archiveDeveloper"
                      @edit="showMoreForm">
          <template slot="organization" slot-scope="{ item }">
            {{item.organization}}<br>
            {{item.department}}
          </template>
          <template slot="location" slot-scope="{ item }">
            {{item.Country.nameRu}}<br>
            {{item.city}}<br>
            {{item.state}}
          </template>
          <template slot="hash" slot-scope="{ item }">
            <span id="foo">
              {{item.backendKeystoreHash}}
            </span>
            <copy-button :text="item.backendKeystoreHash" />
          </template>
        </custom-table>
        <div class="developers__cards" v-if="!this.$store.state.tableView.developers && !showMore">
          <custom-card v-for="item in developers"
                        :key="item.id"
                        :item="item"
                        @show-more="showMoreForm(item)">
            <template slot="icon" @show-more="showMoreForm(item)" >{{item.title.substring(0,1)}}</template>
            <template slot="title">{{item.title}}</template>
            <template slot="content">
              <span>{{item.organization}} {{item.department}}</span>
              <span>Скопировать хэш <copy-button :text="item.backendKeystoreHash"/></span>
            </template>
          </custom-card>
        </div>
        <pagination v-if="totalPages > 1 && !showMore"
                    :page-count="totalPages"
                    :click-handler="onChangePage"
        />
      </div>
      <developer-more v-if="showMore"
                :developer="developerMore"
                 @close="showMore = false"
                 @archive="archiveDeveloper"
      ></developer-more>
    </div>
    <developer-form v-if="showForm"
                    :developer="formDeveloper"
                    @close="showForm = false"
                    @add="addDeveloper"/>
  </div>
</template>

<script>
  import CustomTable from './UIComponents/CustomTable';
  import CustomCard from './UIComponents/CustomCard';
  import Pagination from './UIComponents/Pagination';
  import LimitComponent from './UIComponents/LimitComponent';
  import AddButton from './UIComponents/AddButton';
  import DeveloperForm from './DeveloperForm';
  import DeveloperMore from './DeveloperMore';
  import Spinner from './UIComponents/Spinner';
  import CopyButton from './UIComponents/CopyButton';

  export default {
    components: {
      CustomTable,
      CustomCard,
      Pagination,
      LimitComponent,
      AddButton,
      DeveloperForm,
      DeveloperMore,
      Spinner,
      CopyButton
    },
    data() {
      return {
        developers: [],
        limit: 10,
        offset: 0,
        filter: {},
        totalRows: 0,
        rows: [
          { field: 'title', label: 'Название', align: 'center' },
          { field: 'fullName', label: 'Имя', align: 'center' },
          { field: 'organization', label: 'Организация', align: 'center' },
          { field: 'location', label: 'Местоположение', align: 'center' },
          { field: 'hash', label: 'Хэш', align: 'center' },
        ],
        formDeveloper: {},
        showForm: false,
        developerMore: {},
        showMore: false,
        isBusy: true
      }
    },
    watch: {
      '$store.state.search': function(search) {
        this.filter.search = search;
        this.getDevelopers();
      }
    },
    computed: {
      totalPages: function () {
        return Math.ceil(this.totalRows / this.limit);
      }
    },
    methods: {
      showAddForm() {
        this.formDeveloper = {};
        this.showForm = true;
      },
      showMoreForm(developer) {
        this.developerMore = developer;
        this.showMore = true;
      },
      addDeveloper(developer) {
        this.isBusy = true;
        return this.$API.post('developer', developer)
          .then(() => {
            this.showForm = false;
            this.getDevelopers();
          })
          .catch(() => {
            this.isBusy = false;
          })
      },
      updateDeveloper(developer, message = 'Разработчик успешно обновлен!') {
        this.isBusy = true;
        return this.$API.put(`developer/${developer.id}`, developer)
          .then(() => {
            this.$notify({type: 'success', message});
            return this.getDevelopers();
          })
          .catch(() => {
            this.isBusy = false;
          })
      },
      archiveDeveloper(developer) {
        return this.updateDeveloper({id: developer.id, deleted: 1}, 'Разработчик успешно архивирован!');
      },
      onChangePage(page) {
        this.offset = (page - 1) * this.limit;
        this.getDevelopers();
      },
      getDevelopers() {
        this.isBusy = true;
        return this.$API.get('developers', {params: {...this.filter, limit: this.limit, offset: this.offset}})
          .then(response => {
            this.developers = response.data.rows;
            this.totalRows = response.data.count;
            this.isBusy = false;
          });
      }
    },
    mounted() {
      this.getDevelopers();
    },
    created(){
      if (window.innerWidth <= 780) {
        this.$store.commit("mobileSettings",this.$route.name)
      }
    }
  }
</script>

<style lang="scss">

.developers {
  position: relative;

  &__subheader {
    display: flex;
    align-items: center;
  }

  &__cards {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    span {
      word-wrap: break-word;
    }

    @media screen and (max-width: 870px) {
      justify-content: center;
    }
  }

}

</style>
